
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2EYDP", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $e39tT = parcelRequire("e39tT");


var $elyOj = parcelRequire("elyOj");

function $1a78b7e80091176c$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $fFa3V.bind)(window, {
        type: (0, $e39tT.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $fFa3V.bind)(window, {
        type: (0, $e39tT.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $e39tT.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $fFa3V.bind)(window, {
        type: (0, $e39tT.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $elyOj.getViewportWidth)() !== initialViewPort.w || (0, $elyOj.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $e39tT.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}
module.exports["attachAbortListeners"] = $1a78b7e80091176c$export$9010aa71841a6887;

});

parcelRegister("fFa3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $lRkRh = parcelRequire("lRkRh");

Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $lRkRh.bind;
    }
});

var $8jRth = parcelRequire("8jRth");

Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $8jRth.bindAll;
    }
});

});

parcelRegister("lRkRh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $fe9eba42b47b0c73$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $fe9eba42b47b0c73$var$bind;

});

parcelRegister("8jRth", function(module, exports) {
"use strict";
var $60e99357810b400b$var$__assign = module.exports && module.exports.__assign || function() {
    $60e99357810b400b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $60e99357810b400b$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $lRkRh = parcelRequire("lRkRh");

function $60e99357810b400b$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $60e99357810b400b$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $60e99357810b400b$var$__assign($60e99357810b400b$var$__assign({}, original), {
        options: $60e99357810b400b$var$__assign($60e99357810b400b$var$__assign({}, $60e99357810b400b$var$toOptions(sharedOptions)), $60e99357810b400b$var$toOptions(original.options))
    });
    return binding;
}
function $60e99357810b400b$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $60e99357810b400b$var$getBinding(original, sharedOptions);
        return (0, $lRkRh.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $60e99357810b400b$var$bindAll;

});

parcelRegister("e39tT", function(module, exports) {
const $2fd4bed2a879aa78$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};
module.exports["AbortEvent"] = $2fd4bed2a879aa78$export$199edc0307b5587f;

});

parcelRegister("elyOj", function(module, exports) {
function $82c51b218c57a7bd$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $82c51b218c57a7bd$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
module.exports["getViewportWidth"] = $82c51b218c57a7bd$export$a497a1dcb4408212;
module.exports["getViewportHeight"] = $82c51b218c57a7bd$export$4f01c15d21ef9cc6;

});

parcelRegister("hZpML", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGrzq = parcelRequire("kGrzq");

var $37b533d524acf2b8$export$5cd865dcdb41adf = /*#__PURE__*/ function(WATERFALL_INITIAL_MEASURES) {
    WATERFALL_INITIAL_MEASURES["REDIRECTION"] = "wf/navigation/redirection";
    WATERFALL_INITIAL_MEASURES["DNS"] = "wf/navigation/dns";
    WATERFALL_INITIAL_MEASURES["TCP"] = "wf/navigation/tcp";
    WATERFALL_INITIAL_MEASURES["TLS"] = "wf/navigation/tls";
    WATERFALL_INITIAL_MEASURES["RESPONSE"] = "wf/navigation/response";
    WATERFALL_INITIAL_MEASURES["TTFB"] = "wf/navigation/ttfb";
    WATERFALL_INITIAL_MEASURES["FULL_HTML"] = "wf/navigation/fullHtml";
    WATERFALL_INITIAL_MEASURES["SERVER_TIMING"] = "wf/navigation/serverTiming";
    WATERFALL_INITIAL_MEASURES["CSS_MAIN"] = "wf/css/main";
    WATERFALL_INITIAL_MEASURES["CSS_SUPERBATCH"] = "wf/css/superbatch";
    WATERFALL_INITIAL_MEASURES["CSS_CONNECT_WEB_RESOURCES"] = "wf/css/connectWebResources";
    WATERFALL_INITIAL_MEASURES["CSS_COMPILED"] = "wf/css/compiled";
    WATERFALL_INITIAL_MEASURES["JS_SUPERBATCH"] = "wf/js/superbatch";
    WATERFALL_INITIAL_MEASURES["JS_CONNECT_WEB_RESOURCES"] = "wf/js/connectWebResources";
    WATERFALL_INITIAL_MEASURES["HTML_THEME_INIT"] = "wf/html/themeInit";
    WATERFALL_INITIAL_MEASURES["HTML_REACT_ROOT"] = "wf/html/reactRoot";
    WATERFALL_INITIAL_MEASURES["HTML_SSR_SCRIPTS"] = "wf/html/ssrScripts";
    WATERFALL_INITIAL_MEASURES["HTML_TOP_NAV"] = "wf/html/topNav";
    WATERFALL_INITIAL_MEASURES["HTML_SIDE_NAV"] = "wf/html/sideNav";
    WATERFALL_INITIAL_MEASURES["HTML_MAIN"] = "wf/html/main";
    WATERFALL_INITIAL_MEASURES["HTML_FORCE_LAYOUT"] = "wf/html/forceLayout";
    WATERFALL_INITIAL_MEASURES["SSR_GLOBALS"] = "wf/html/ssrGlobals";
    WATERFALL_INITIAL_MEASURES["COLLECT_PLACEHOLDER_DIMENSIONS"] = "wf/bootstrap/collectPlaceholderDimensions";
    WATERFALL_INITIAL_MEASURES["SSR_BEFORE_SCRIPTS"] = "wf/bootstrap/ssrBeforeScripts";
    WATERFALL_INITIAL_MEASURES["SSR_AFTER_SCRIPTS"] = "wf/bootstrap/ssrAfterScripts";
    WATERFALL_INITIAL_MEASURES["CREATE_APOLLO_CLIENTS"] = "wf/bootstrap/createApolloClients";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_SESSION_DATA"] = "wf/bootstrap/getSessionData";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_TRANSLATION"] = "wf/bootstrap/loadTranslation";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_LOADABLE"] = "wf/bootstrap/preloadLoadable";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_INITIALIZE_STORAGE_MANAGER"] = "wf/bootstrap/initializeStorageManager";
    WATERFALL_INITIAL_MEASURES["BOOTSTRAP_INITIALIZE_COOKIES"] = "wf/bootstrap/initializeCookies";
    return WATERFALL_INITIAL_MEASURES;
}({});
const $37b533d524acf2b8$export$deb9bd49feb08fb5 = [
    'atl-edge-internal',
    'atl-edge-upstream',
    'cdn-upstream-fbl',
    'cdn-upstream-dns',
    'cdn-upstream-connect',
    'cdn-downstream-fbl'
];
function $37b533d524acf2b8$export$61a691dabeb80f51(name) {
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window["__SSR_RENDERED__"]&&window.performance.mark("${name}");`
        }
    });
}
class $37b533d524acf2b8$var$WaterfallMeasure extends (0, $kGrzq.BaseMeasures) {
    markMeasureStart(name, timestamp) {
        this.markedKeys.add(name);
        window.performance.clearMarks(`${name}.start`);
        window.performance.mark(`${name}.start`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    markMeasureEnd(name, timestamp) {
        window.performance.clearMarks(`${name}.end`);
        window.performance.mark(`${name}.end`, {
            startTime: Math.floor(timestamp ?? performance.now())
        });
    }
    getMeasureKeys(after) {
        return Array.from(this.markedKeys).filter((key)=>{
            const mark = performance.getEntriesByName(`${key}.start`, 'mark');
            return mark.length && mark[0].startTime >= after;
        });
    }
    clearMeasures() {
        super.clearMeasures();
        this.markedKeys.clear();
    }
    constructor(...args){
        super(...args);
        this.markedKeys = new Set();
    }
}
const $37b533d524acf2b8$export$d7d6a49c52882aad = new $37b533d524acf2b8$var$WaterfallMeasure();
module.exports["WATERFALL_INITIAL_MEASURES"] = $37b533d524acf2b8$export$5cd865dcdb41adf;
module.exports["SERVER_TIMING_MEASURES"] = $37b533d524acf2b8$export$deb9bd49feb08fb5;
module.exports["perfMark"] = $37b533d524acf2b8$export$61a691dabeb80f51;
module.exports["WaterfallMeasures"] = $37b533d524acf2b8$export$d7d6a49c52882aad;

});

parcelRegister("42omo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6pzYC"));

});

parcelRegister("6pzYC", function(module, exports) {
$parcel$export(module.exports, "Children", () => $4ab0fc1563709023$export$dca3b0875bd9a954, (v) => $4ab0fc1563709023$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $4ab0fc1563709023$export$16fa2f45be04daa8, (v) => $4ab0fc1563709023$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $4ab0fc1563709023$export$ffb0004e005737fa, (v) => $4ab0fc1563709023$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $4ab0fc1563709023$export$e2c29f18771995cb, (v) => $4ab0fc1563709023$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $4ab0fc1563709023$export$221d75b3f55bb0bd, (v) => $4ab0fc1563709023$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $4ab0fc1563709023$export$5f8d39834fd61797, (v) => $4ab0fc1563709023$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $4ab0fc1563709023$export$74bf444e3cd11ea5, (v) => $4ab0fc1563709023$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $4ab0fc1563709023$export$ae55be85d98224ed, (v) => $4ab0fc1563709023$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $4ab0fc1563709023$export$3ba232387fd5d6dd, (v) => $4ab0fc1563709023$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $4ab0fc1563709023$export$e530037191fcd5d7, (v) => $4ab0fc1563709023$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $4ab0fc1563709023$export$fd42f52fd3ae1109, (v) => $4ab0fc1563709023$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $4ab0fc1563709023$export$c8a8987d4410bf2d, (v) => $4ab0fc1563709023$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $4ab0fc1563709023$export$d38cd72104c1f0e9, (v) => $4ab0fc1563709023$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $4ab0fc1563709023$export$7d1e3a5e95ceca43, (v) => $4ab0fc1563709023$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $4ab0fc1563709023$export$257a8862b851cb5b, (v) => $4ab0fc1563709023$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $4ab0fc1563709023$export$a8257692ac88316c, (v) => $4ab0fc1563709023$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $4ab0fc1563709023$export$488013bae63b21da, (v) => $4ab0fc1563709023$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $4ab0fc1563709023$export$7c73462e0d25e514, (v) => $4ab0fc1563709023$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $4ab0fc1563709023$export$7568632d0d33d16d, (v) => $4ab0fc1563709023$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $4ab0fc1563709023$export$88948ce120ea2619, (v) => $4ab0fc1563709023$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $4ab0fc1563709023$export$35808ee640e87ca7, (v) => $4ab0fc1563709023$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $4ab0fc1563709023$export$fae74005e78b1a27, (v) => $4ab0fc1563709023$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $4ab0fc1563709023$export$dc8fbce3eb94dc1e, (v) => $4ab0fc1563709023$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $4ab0fc1563709023$export$6a7bc4e911dc01cf, (v) => $4ab0fc1563709023$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $4ab0fc1563709023$export$6d9c69b0de29b591, (v) => $4ab0fc1563709023$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $4ab0fc1563709023$export$f680877a34711e37, (v) => $4ab0fc1563709023$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $4ab0fc1563709023$export$d5a552a76deda3c2, (v) => $4ab0fc1563709023$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $4ab0fc1563709023$export$aaabe4eda9ed9969, (v) => $4ab0fc1563709023$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $4ab0fc1563709023$export$e5c5a5f917a5871c, (v) => $4ab0fc1563709023$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $4ab0fc1563709023$export$1538c33de8887b59, (v) => $4ab0fc1563709023$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $4ab0fc1563709023$export$13e3392192263954, (v) => $4ab0fc1563709023$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $4ab0fc1563709023$export$b8f5890fc79d6aca, (v) => $4ab0fc1563709023$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $4ab0fc1563709023$export$60241385465d0a34, (v) => $4ab0fc1563709023$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $4ab0fc1563709023$export$306c0aa65ff9ec16, (v) => $4ab0fc1563709023$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $4ab0fc1563709023$export$7b286972b8d8ccbf, (v) => $4ab0fc1563709023$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $4ab0fc1563709023$export$83d89fbfd8236492, (v) => $4ab0fc1563709023$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4ab0fc1563709023$export$dca3b0875bd9a954;
var $4ab0fc1563709023$export$16fa2f45be04daa8;
var $4ab0fc1563709023$export$ffb0004e005737fa;
var $4ab0fc1563709023$export$e2c29f18771995cb;
var $4ab0fc1563709023$export$221d75b3f55bb0bd;
var $4ab0fc1563709023$export$5f8d39834fd61797;
var $4ab0fc1563709023$export$74bf444e3cd11ea5;
var $4ab0fc1563709023$export$ae55be85d98224ed;
var $4ab0fc1563709023$export$3ba232387fd5d6dd;
var $4ab0fc1563709023$export$e530037191fcd5d7;
var $4ab0fc1563709023$export$fd42f52fd3ae1109;
var $4ab0fc1563709023$export$c8a8987d4410bf2d;
var $4ab0fc1563709023$export$d38cd72104c1f0e9;
var $4ab0fc1563709023$export$7d1e3a5e95ceca43;
var $4ab0fc1563709023$export$257a8862b851cb5b;
var $4ab0fc1563709023$export$a8257692ac88316c;
var $4ab0fc1563709023$export$488013bae63b21da;
var $4ab0fc1563709023$export$7c73462e0d25e514;
var $4ab0fc1563709023$export$7568632d0d33d16d;
var $4ab0fc1563709023$export$88948ce120ea2619;
var $4ab0fc1563709023$export$35808ee640e87ca7;
var $4ab0fc1563709023$export$fae74005e78b1a27;
var $4ab0fc1563709023$export$dc8fbce3eb94dc1e;
var $4ab0fc1563709023$export$6a7bc4e911dc01cf;
var $4ab0fc1563709023$export$6d9c69b0de29b591;
var $4ab0fc1563709023$export$f680877a34711e37;
var $4ab0fc1563709023$export$d5a552a76deda3c2;
var $4ab0fc1563709023$export$aaabe4eda9ed9969;
var $4ab0fc1563709023$export$e5c5a5f917a5871c;
var $4ab0fc1563709023$export$1538c33de8887b59;
var $4ab0fc1563709023$export$13e3392192263954;
var $4ab0fc1563709023$export$b8f5890fc79d6aca;
var $4ab0fc1563709023$export$60241385465d0a34;
var $4ab0fc1563709023$export$306c0aa65ff9ec16;
var $4ab0fc1563709023$export$7b286972b8d8ccbf;
var $4ab0fc1563709023$export$83d89fbfd8236492;
'use strict';
var $4ab0fc1563709023$var$l = Symbol.for("react.element"), $4ab0fc1563709023$var$n = Symbol.for("react.portal"), $4ab0fc1563709023$var$p = Symbol.for("react.fragment"), $4ab0fc1563709023$var$q = Symbol.for("react.strict_mode"), $4ab0fc1563709023$var$r = Symbol.for("react.profiler"), $4ab0fc1563709023$var$t = Symbol.for("react.provider"), $4ab0fc1563709023$var$u = Symbol.for("react.context"), $4ab0fc1563709023$var$v = Symbol.for("react.forward_ref"), $4ab0fc1563709023$var$w = Symbol.for("react.suspense"), $4ab0fc1563709023$var$x = Symbol.for("react.memo"), $4ab0fc1563709023$var$y = Symbol.for("react.lazy"), $4ab0fc1563709023$var$z = Symbol.iterator;
function $4ab0fc1563709023$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4ab0fc1563709023$var$z && a[$4ab0fc1563709023$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4ab0fc1563709023$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4ab0fc1563709023$var$C = Object.assign, $4ab0fc1563709023$var$D = {};
function $4ab0fc1563709023$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4ab0fc1563709023$var$D;
    this.updater = e || $4ab0fc1563709023$var$B;
}
$4ab0fc1563709023$var$E.prototype.isReactComponent = {};
$4ab0fc1563709023$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4ab0fc1563709023$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4ab0fc1563709023$var$F() {}
$4ab0fc1563709023$var$F.prototype = $4ab0fc1563709023$var$E.prototype;
function $4ab0fc1563709023$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4ab0fc1563709023$var$D;
    this.updater = e || $4ab0fc1563709023$var$B;
}
var $4ab0fc1563709023$var$H = $4ab0fc1563709023$var$G.prototype = new $4ab0fc1563709023$var$F;
$4ab0fc1563709023$var$H.constructor = $4ab0fc1563709023$var$G;
$4ab0fc1563709023$var$C($4ab0fc1563709023$var$H, $4ab0fc1563709023$var$E.prototype);
$4ab0fc1563709023$var$H.isPureReactComponent = !0;
var $4ab0fc1563709023$var$I = Array.isArray, $4ab0fc1563709023$var$J = Object.prototype.hasOwnProperty, $4ab0fc1563709023$var$K = {
    current: null
}, $4ab0fc1563709023$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4ab0fc1563709023$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4ab0fc1563709023$var$J.call(b, d) && !$4ab0fc1563709023$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4ab0fc1563709023$var$K.current
    };
}
function $4ab0fc1563709023$var$N(a, b) {
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4ab0fc1563709023$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4ab0fc1563709023$var$l;
}
function $4ab0fc1563709023$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4ab0fc1563709023$var$P = /\/+/g;
function $4ab0fc1563709023$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4ab0fc1563709023$var$escape("" + a.key) : b.toString(36);
}
function $4ab0fc1563709023$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4ab0fc1563709023$var$l:
                case $4ab0fc1563709023$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4ab0fc1563709023$var$Q(h, 0) : d, $4ab0fc1563709023$var$I(c) ? (e = "", null != a && (e = a.replace($4ab0fc1563709023$var$P, "$&/") + "/"), $4ab0fc1563709023$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4ab0fc1563709023$var$O(c) && (c = $4ab0fc1563709023$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4ab0fc1563709023$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4ab0fc1563709023$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4ab0fc1563709023$var$Q(k, g);
        h += $4ab0fc1563709023$var$R(k, b, e, f, c);
    }
    else if (f = $4ab0fc1563709023$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4ab0fc1563709023$var$Q(k, g++), h += $4ab0fc1563709023$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4ab0fc1563709023$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4ab0fc1563709023$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4ab0fc1563709023$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4ab0fc1563709023$var$U = {
    current: null
}, $4ab0fc1563709023$var$V = {
    transition: null
}, $4ab0fc1563709023$var$W = {
    ReactCurrentDispatcher: $4ab0fc1563709023$var$U,
    ReactCurrentBatchConfig: $4ab0fc1563709023$var$V,
    ReactCurrentOwner: $4ab0fc1563709023$var$K
};
function $4ab0fc1563709023$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$4ab0fc1563709023$export$dca3b0875bd9a954 = {
    map: $4ab0fc1563709023$var$S,
    forEach: function(a, b, e) {
        $4ab0fc1563709023$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4ab0fc1563709023$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4ab0fc1563709023$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4ab0fc1563709023$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4ab0fc1563709023$export$16fa2f45be04daa8 = $4ab0fc1563709023$var$E;
$4ab0fc1563709023$export$ffb0004e005737fa = $4ab0fc1563709023$var$p;
$4ab0fc1563709023$export$e2c29f18771995cb = $4ab0fc1563709023$var$r;
$4ab0fc1563709023$export$221d75b3f55bb0bd = $4ab0fc1563709023$var$G;
$4ab0fc1563709023$export$5f8d39834fd61797 = $4ab0fc1563709023$var$q;
$4ab0fc1563709023$export$74bf444e3cd11ea5 = $4ab0fc1563709023$var$w;
$4ab0fc1563709023$export$ae55be85d98224ed = $4ab0fc1563709023$var$W;
$4ab0fc1563709023$export$3ba232387fd5d6dd = $4ab0fc1563709023$var$X;
$4ab0fc1563709023$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4ab0fc1563709023$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4ab0fc1563709023$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4ab0fc1563709023$var$J.call(b, f) && !$4ab0fc1563709023$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4ab0fc1563709023$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4ab0fc1563709023$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4ab0fc1563709023$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4ab0fc1563709023$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4ab0fc1563709023$export$c8a8987d4410bf2d = $4ab0fc1563709023$var$M;
$4ab0fc1563709023$export$d38cd72104c1f0e9 = function(a) {
    var b = $4ab0fc1563709023$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4ab0fc1563709023$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4ab0fc1563709023$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4ab0fc1563709023$var$v,
        render: a
    };
};
$4ab0fc1563709023$export$a8257692ac88316c = $4ab0fc1563709023$var$O;
$4ab0fc1563709023$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4ab0fc1563709023$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4ab0fc1563709023$var$T
    };
};
$4ab0fc1563709023$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4ab0fc1563709023$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4ab0fc1563709023$export$7568632d0d33d16d = function(a) {
    var b = $4ab0fc1563709023$var$V.transition;
    $4ab0fc1563709023$var$V.transition = {};
    try {
        a();
    } finally{
        $4ab0fc1563709023$var$V.transition = b;
    }
};
$4ab0fc1563709023$export$88948ce120ea2619 = $4ab0fc1563709023$var$X;
$4ab0fc1563709023$export$35808ee640e87ca7 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useCallback(a, b);
};
$4ab0fc1563709023$export$fae74005e78b1a27 = function(a) {
    return $4ab0fc1563709023$var$U.current.useContext(a);
};
$4ab0fc1563709023$export$dc8fbce3eb94dc1e = function() {};
$4ab0fc1563709023$export$6a7bc4e911dc01cf = function(a) {
    return $4ab0fc1563709023$var$U.current.useDeferredValue(a);
};
$4ab0fc1563709023$export$6d9c69b0de29b591 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useEffect(a, b);
};
$4ab0fc1563709023$export$f680877a34711e37 = function() {
    return $4ab0fc1563709023$var$U.current.useId();
};
$4ab0fc1563709023$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useImperativeHandle(a, b, e);
};
$4ab0fc1563709023$export$aaabe4eda9ed9969 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useInsertionEffect(a, b);
};
$4ab0fc1563709023$export$e5c5a5f917a5871c = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useLayoutEffect(a, b);
};
$4ab0fc1563709023$export$1538c33de8887b59 = function(a, b) {
    return $4ab0fc1563709023$var$U.current.useMemo(a, b);
};
$4ab0fc1563709023$export$13e3392192263954 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useReducer(a, b, e);
};
$4ab0fc1563709023$export$b8f5890fc79d6aca = function(a) {
    return $4ab0fc1563709023$var$U.current.useRef(a);
};
$4ab0fc1563709023$export$60241385465d0a34 = function(a) {
    return $4ab0fc1563709023$var$U.current.useState(a);
};
$4ab0fc1563709023$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4ab0fc1563709023$var$U.current.useSyncExternalStore(a, b, e);
};
$4ab0fc1563709023$export$7b286972b8d8ccbf = function() {
    return $4ab0fc1563709023$var$U.current.useTransition();
};
$4ab0fc1563709023$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("kGrzq", function(module, exports) {
/* eslint-disable no-dupe-class-members */ class $533cd45aab169de9$export$31c6869b8bca23f6 {
    run(name, fn) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name)=>this.markMeasureStart(name));
        const result = fn();
        if (typeof result?.then === 'function') // eslint-disable-next-line @typescript-eslint/no-floating-promises
        result.finally(()=>{
            names.forEach((name)=>this.markMeasureEnd(name));
        });
        else names.forEach((name)=>this.markMeasureEnd(name));
        return result;
    }
    markMeasureStart(name, timestamp) {
        //if startTime already marked, don't mark again.
        if (this.measures[name]?.startTime) return;
        this.measures[name] = {
            startTime: Math.floor(timestamp ?? performance.now()),
            duration: 0
        };
    }
    markMeasureEnd(name, timestamp, allowEndOnly = false) {
        const entry = this.measures[name];
        if (!entry?.duration && entry?.startTime) entry.duration = Math.floor((timestamp ?? performance.now()) - entry.startTime);
        else if (!entry && allowEndOnly) // In allowEndOnly mode we take FIRST end time as duration
        this.measures[name] = {
            startTime: 0,
            duration: timestamp ?? performance.now()
        };
    }
    getMeasures() {
        return this.measures;
    }
    clearMeasures() {
        this.measures = {};
    }
    constructor(){
        this.measures = {};
    }
}
module.exports["BaseMeasures"] = $533cd45aab169de9$export$31c6869b8bca23f6;

});


var $2EYDP = parcelRequire("2EYDP");


var $elyOj = parcelRequire("elyOj");

function $ecacdc4534090d1e$export$7c71cffb8af72558(document, window) {
    const viewport = {
        w: (0, $elyOj.getViewportWidth)(document),
        h: (0, $elyOj.getViewportHeight)(document)
    };
    const aborts = {};
    const unbinds = (0, $2EYDP.attachAbortListeners)(window, viewport, (key, time)=>{
        aborts[key] = time;
    });
    window.__SSR_ABORT_LISTENERS__ = {
        unbinds: unbinds,
        aborts: aborts
    };
}



var $hZpML = parcelRequire("hZpML");

window?.performance?.mark?.(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).SSR_BEFORE_SCRIPTS}.start`);
// Runs before the HTML body, it is NOT safe to assume SSR has been successful rendered
// This is why we don't check for `window.__SSR_RENDERED__` here
(0, $ecacdc4534090d1e$export$7c71cffb8af72558)(document, window);
window?.performance?.mark?.(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).SSR_BEFORE_SCRIPTS}.end`);


//# sourceMappingURL=ssr-scripts-before.155d1a63.js.map
